import { Nullable } from '../../types/common'
import BaseComponent from '../base-component/base-component'
import Cart from './cart'

class CartCountdownBlock extends BaseComponent {
  cart: Nullable<Cart>

  constructor() {
    super()

    this.cart = this.closest('cart-page')
  }

  connectedCallback(): void {
    if (this.cart) {
      this.cart.subscribe('update-nodes', this.handleFinishCartUpdate)
    }
  }

  disconnectedCallback(): void {
    if (this.cart) {
      this.cart.unsubscribe('update-nodes', this.handleFinishCartUpdate)
    }
  }

  handleFinishCartUpdate = ({ node }): void => {
    this.updateByNode(node)
  }

  updateByNode(node: HTMLElement): void {
    const blockId = this.getAttribute('block-id')
    const newCountdownBlock = node.querySelector(
      `cart-countdown-block[block-id="${blockId}"]`,
    )

    if (!newCountdownBlock) {
      return
    }

    const clonedNewCountdownBlock = newCountdownBlock.cloneNode(true)

    this.replaceChildren(...clonedNewCountdownBlock.childNodes)
  }
}

export default CartCountdownBlock
